import React, { Fragment } from 'react'
import SearchContext from '../SearchContext'
import {
  fade,
  makeStyles,
  createMuiTheme,
  ThemeProvider
} from '@material-ui/core/styles'
import MomentUtils from '@date-io/moment'
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers'
import { lightBlue, red } from '@material-ui/core/colors'
import TextField from '@material-ui/core/TextField'
const useStyles = makeStyles(theme => ({
  divide: {
    minWidth: 150
  }
}))
const materialTheme = createMuiTheme({
  overrides: {
    MuiPickersToolbar: {
      root: {
        backgroundColor: lightBlue.A200,
        spacing: '2px'
      }
    },
    MuiPickersCalendarHeader: {
      root: {
        backgroundColor: red.A200,
        color: lightBlue['100']
      }
    },
    MuiPickersDay: {
      root: {
        color: lightBlue.A700,
        '&$disabled': {
          color: lightBlue['100']
        },
        '&$selected': {
          backgroundColor: lightBlue['400']
        }
      },
      today: {
        color: lightBlue['900']
      }
    },
    MuiPickersModalDialog: {
      dialogAction: {
        color: lightBlue['400']
      }
    }
  }
})
export default function DefaultDate () {
  const { selectedDate, setSelectedDate } = React.useContext(SearchContext)
  const classes = useStyles()

  const handleDateChange = date => {
    //const newDate = date + ''
    //setIsDisabled(isDisabled => !isDisabled)
    setSelectedDate(date)
  }

  return (
    <ThemeProvider theme={materialTheme}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <div className={classes.divide}>
          <DatePicker
            size={'small'}
            allowKeyboardControl={false}
            id='date-picker-dialog'
            format='DD/MM/YY'
            value={selectedDate}
            onChange={handleDateChange}
            keyboardbuttonprops={{
              'aria-label': 'change date'
            }}
          />
        </div>
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  )
}
//renderinput = { props => < TextField {...props } />}
